import { TimeGranularity } from "@/01-core/entity/entities/entity";
import { TableConfigSchema } from "@/app/[locale]/tiktok/entity/[...entityAndView]/table/schema";
import db from "@/lib/hard-delete-db";
import {
  endOfMonth,
  endOfWeek,
  getTime,
  parse,
  startOfMonth,
  startOfWeek,
  subDays,
  getHours,
  startOfDay,
  endOfDay,
  format,
} from "date-fns";
import { isNil } from "lodash";
import { NextResponse } from "next/server";
export const DEFAULT_ALL = "_all_";
export const countryImgUrl = (countryCode: string) => {
  const urlPrefix = "/images/flag";
  const countryCodeList = [...countryList, ...extraCountryList].map(
    (country) => country.code,
  );
  if (countryCodeList.includes(countryCode)) {
    return `${urlPrefix}/${countryCode}.svg`;
  }
  return "";
};

export const getCountryName = (countryCode: string) => {
  const allCountryList = [...countryList, ...extraCountryList];
  const countryCodeList = allCountryList.map((country) => country.code);
  if (countryCodeList.includes(countryCode)) {
    return allCountryList.find((country) => country.code === countryCode)
      ?.countryName;
  }
  return "";
};
export const BEIJING_NOW_DATE = new Date(
  new Date().toLocaleString("en-US", {
    timeZone: "Asia/Shanghai",
  }),
);

export const BEIJING_NOW_DATE_FUNC = () => {
  return new Date(
    new Date().toLocaleString("en-US", {
      timeZone: "Asia/Shanghai",
    }),
  );
};

export const DEFAULT_PAGEINDEX_KEY = "pageIndex";
export const DEFAULT_START_DATE_FUNC = () => {
  const beijingNowDate = BEIJING_NOW_DATE_FUNC();
  if (getHours(beijingNowDate) < 15) {
    return subDays(beijingNowDate, 2);
  }
  return subDays(beijingNowDate, 1);
};
export const DEFAULT_START_DATE = (() => {
  if (getHours(BEIJING_NOW_DATE) < 15) {
    return subDays(BEIJING_NOW_DATE, 2);
  }
  return subDays(BEIJING_NOW_DATE, 1);
})();
export const getHomepageUpdateTime = () => {
  if (getHours(BEIJING_NOW_DATE) < 15) {
    return (
      "最新数据更新于" +
      format(subDays(BEIJING_NOW_DATE, 1), "yyyy/MM/dd") +
      " 15:00(UTC+8:00)"
    );
  }
  return (
    "最新数据更新于" +
    format(BEIJING_NOW_DATE, "yyyy/MM/dd") +
    " 15:00(UTC+8:00)"
  );
};
export const M_HOMEPAGE_UPDATE_TIME = (() => {
  if (getHours(BEIJING_NOW_DATE) < 15) {
    return (
      format(subDays(BEIJING_NOW_DATE, 1), "yyyy/MM/dd") + " 15:00(UTC+8:00)"
    );
  }
  return format(BEIJING_NOW_DATE, "yyyy/MM/dd") + " 15:00(UTC+8:00)";
})();
export const MX_DISABLED_BEFORE_DATE = new Date("2025-02-06");
export const EUROPE_DISABLED_BEFORE_DATE = new Date("2025-05-12");
export const ASIA_DASHBOARD_DISABLED_BEFORE_DATE = new Date("2025-03-10");
export const ASIA_DASHBOARD_DISABLED_MONTH_BEFORE_DATE = new Date("2025-03-31");
export const DISABLED_BEFORE_DATE = new Date("2024-03-15");
export const PROMOTION_DISABLED_BEFORE_DATE = new Date("2024-07-01");
export const ASIA_DISABLED_BEFORE_DATE = new Date("2025-01-13");
export const VN_DISABLED_BEFORE_DATE = new Date("2025-01-18");
export const AGENCY_DISABLED_BEFORE_DATE = new Date("2025-01-01");
export const JP_DISABLED_BEFORE_DATE = new Date("2025-06-10");
export const API_BASE = process.env.API_BASE ?? "";
export const API_BASE_V2 = process.env.API_BASE_V2 ?? "";
export const API_BASE_V3 = process.env.API_BASE_V3 ?? "";
export const API_BASIC_AUTH_V2 = process.env.API_BASIC_AUTH_V2 ?? "";
export const FALLBACK_IMG_SRC = "/fallback.svg";
export const VIDEO_LICENSE_SIGN =
  process.env.NEXT_PUBLIC_VIDEO_LICENSE_SIGN ?? "";
export const VIDEO_LICENSE_CONTENT =
  process.env.NEXT_PUBLIC_VIDEO_LICENSE_CONTENT ?? "";
export const VIDEO_LICENSE_MAIN_URL =
  process.env.NEXT_PUBLIC_VIDEO_LICENSE_MAIN_URL ?? "";
export const VIDEO_LINE_APP_ID =
  process.env.NEXT_PUBLIC_VIDEO_LINE_APP_ID ?? "";
export function formatNumber(
  value: number | null | undefined,
  toFiexedNum = 2,
  needFixexNum = false,
) {
  if (isNil(value)) {
    return "0";
  }

  const absValue = Math.abs(value);
  const sign = value < 0 ? "-" : "";

  if (absValue < 10000) {
    if (needFixexNum) {
      return sign + absValue.toFixed(toFiexedNum);
    }
    return sign + Math.round(absValue).toString();
  }

  if (absValue >= 10000 && absValue < 100000000) {
    return sign + (absValue / 10000).toFixed(toFiexedNum) + "万";
  }

  if (absValue >= 100000000) {
    return sign + (absValue / 100000000).toFixed(toFiexedNum) + "亿";
  }

  return `${value}`;
}

export const formatTimeToStartEnd = (
  startDateTime: string,
  granularity: TimeGranularity,
) => {
  const date = parse(startDateTime, "yyyyMMdd", new Date());
  if (granularity === TimeGranularity.DAILY) {
    return {
      start_timestamp: getTime(startOfDay(date)),
      end_timestamp: getTime(endOfDay(date)),
    };
  }
  if (granularity === TimeGranularity.WEEKLY) {
    return {
      start_timestamp: getTime(startOfWeek(date, { weekStartsOn: 1 })),
      end_timestamp: getTime(endOfWeek(date, { weekStartsOn: 1 })),
    };
  }
  if (granularity === TimeGranularity.MONTHLY) {
    return {
      start_timestamp: getTime(startOfMonth(date)),
      end_timestamp: getTime(endOfMonth(date)),
    };
  }
};
export enum EXPORT_ERROR_CODE {
  EXPORT_LIMIT_EXCEPTION = 1100,
  GET_CAPTCHA_FAIL = 1101,
  CAPTCHA_VERIFY_FAIL = 1102,
  CAPTCHA_VERIFY_TIMEOUT = 1103,
}
export enum EXPORT_ERROR_CODE_V2 {
  EXPORT_LIMIT_EXCEPTION = 2016,
}
export enum UNAUTHORIZED_CODE {
  UNAUTHORIZED_ERROR = 2100,
  OUT_OF_LIMIT_ERROR = 2200,
}
export const productStatusMap: Record<string, string> = {
  "2.0": "该商品暂时下架",
  "4.0": "该商品已被删除",
};

export const productStatusMapV2: Record<string, string> = {
  2: "该商品暂时下架",
  4: "该商品已被删除",
};

export type BaseResp = {
  code: number;
  msg: string;
};

export class ErrorBase<T extends string> extends Error {
  name: T;
  message: string;
  cause?: unknown;
  originalError?: Error;
  baseResp?: BaseResp;

  constructor({
    name,
    message,
    cause,
    originalError,
    baseResp,
  }: {
    name: T;
    message: string;
    baseResp?: BaseResp;
    cause?: unknown;
    originalError?: Error;
  }) {
    super();
    this.name = name;
    this.message = message;
    this.cause = cause;
    this.originalError = originalError;
    this.baseResp = baseResp;
  }
}

export const responseTransfer = async (res: Response) => {
  try {
    const respHeaders = new Headers(res.headers);
    respHeaders.delete("content-encoding");
    respHeaders.delete("content-length");
    let resJSON;
    let resText;
    resText = await res.text();
    resJSON = JSON.parse(resText);
    return NextResponse.json(resJSON, {
      statusText: res.statusText,
      headers: respHeaders,
      status: res.status,
    });
  } catch (error) {
    return NextResponse.json(
      {
        msg: "backend api error",
        error: String(error),
        code: 500,
      },
      {
        status: 500,
      },
    );
  }
};
export const productType = [
  "tiktok_creator_search_has_live_product",
  "tiktok_creator_search_has_video_product",
  "tiktok_creator_search_has_shop_product",
];
export const contactType = [
  "tiktok_creator_search_has_x",
  "tiktok_creator_search_has_ins",
  "tiktok_creator_search_has_youtube",
  "tiktok_creator_search_has_email",
  "tiktok_creator_search_has_facebook",
  "tiktok_creator_search_has_telegram",
  "tiktok_creator_search_has_linkedin",
  "tiktok_creator_search_has_whatsapp",
];
export const isHasProductKey = "tiktok_creator_search_has_product";
export const isHasContactKey = "tiktok_creator_search_has_contact";
// export const shouldHideKey = ["avg_views", "creator_avg_product_live_uv"];
export const shouldHideKey = [];
// export const shouldHideWhileHasProductIsFalseKey = [
//   "ec_video_count",
//   "creator_product_live_count",
//   "product_count",
//   "creator_product_gmv_for_last_7_days",
// ];
export const shouldHideWhileHasProductIsFalseKey = [];
export const creatorRelatedVideoMap: Record<string, string> = {
  sellerRelatedCreators: "seller_video",
  productRelatedCreators: "product_video",
};
export const creatorRelatedLiveMap: Record<string, string> = {
  sellerRelatedCreators: "seller_live",
  productRelatedCreators: "product_live",
};
export const opinionTypeKey = "tiktok_product_detail_review_opinion_type";
export const emotionTypeKey = "tiktok_product_detail_review_opinion_emotion";
export const opinionKey = "tiktok_product_detail_review_opinion_detail";

export const videoOpinionTypeKey = "tiktok_video_detail_review_opinion_type";
export const videoEmotionTypeKey = "tiktok_video_detail_review_opinion_emotion";
export const videoOpinionKey = "tiktok_video_detail_review_opinion_detail";

export const userNamePattern = /^[a-zA-Z0-9_]{3,16}$/;
export type I18nMap = Record<string, { zh: string; en: string }>;

const retryOperation = async <T>(
  operation: () => Promise<T>,
  maxRetries = 3,
): Promise<T> => {
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      return await operation();
    } catch (error) {
      if (attempt === maxRetries) throw error;

      const delay = Math.min(1000 * Math.pow(2, attempt), 10000);
      const jitter = delay * 0.2 * Math.random();
      await new Promise((resolve) => setTimeout(resolve, delay + jitter));
    }
  }
  throw new Error("Retry failed");
};

export async function getTableConfig(
  entityTypeName: string,
  entityViewName: string,
) {
  const dbData = await db.tableConfig.findFirst({
    where: {
      entityName: entityTypeName,
      viewName: entityViewName,
    },
    orderBy: {
      version: "desc",
    },
  });
  const tableConfig = TableConfigSchema.parse({
    meta: {
      tableId: dbData?.tableId,
      version: dbData?.version,
      apiPath: dbData?.apiPath,
      entityName: dbData?.entityName,
      viewName: dbData?.viewName,
      resourceKey: dbData?.resourceKey,
      relatedEntityName: dbData?.relatedEntityName,
    },
    ...(dbData?.tableConfigJson as object),
  });
  const beFieldKeys = tableConfig.tableCols.flatMap((col) =>
    col.fieldList.map((field) => field.beFieldKey),
  );
  const res = await retryOperation(() =>
    db.field_i18n.findMany({
      where: { field_key: { in: beFieldKeys }, deletedAt: null },
      select: {
        field_key: true,
        translation_key: true,
        tips_translation_key: true,
        tips_translation: true,
      },
    }),
  );
  const beFieldKeyI18nMap = res.map((f) => ({
    fieldKey: f.field_key,
    i18nKey: f.translation_key,
    tipsI18nKey: f.tips_translation_key,
    tips: f.tips_translation
      ? {
          zh: f.tips_translation?.zh,
          en: f.tips_translation?.en,
        }
      : undefined,
  }));
  return { tableConfig, beFieldKeyI18nMap };
}
export async function getTableConfigFromClient(
  entityTypeName: string,
  entityViewName: string,
) {
  const res = await fetch(
    `/api/tableConfig?entityTypeName=${entityTypeName}&entityViewName=${entityViewName}`,
    {
      next: {
        revalidate: 60 * 60,
      },
    },
  );
  return res.json() as ReturnType<typeof getTableConfig>;
}
export const adTypeMap: Record<number | string, string> = {
  1: "TikTok Shop 广告",
  2: "独立站广告",
  3: "应用广告",
  4: "游戏广告",
  5: "品牌广告",
  6: "线索广告",
  7: "互动广告",
};
export const objectiveMap: Record<number, string> = {
  1: "访问量",
  3: "网页转化量",
  4: "视频播放量",
  5: "覆盖人数",
  7: "覆盖人数 & 频率",
  8: "线索收集",
  9: "互动广告",
  15: "商品营销",
  16: "应用推广",
  50: "品牌广告",
  51: "品牌广告",
};
export const showGetFreeMemberModalKey = "showModal";
export const shareCodeKey = "shareCode";
export enum AiTaskStatusEnum {
  UnSubmitted = 0,
  InProgress = 1,
  Failed = 2,
  Success = 3,
}
export const ALL_VALUE = "_ALL_";

export const IS_PRE = process.env.API_BASE_V2?.includes("pre");
export const IS_PROD =
  process.env.API_BASE_V2?.includes("chuhaijiang") ||
  process.env.API_BASE_V2?.includes("hertz-server.server.svc.cluster.local");
export const IS_DEV = process.env.NODE_ENV === "development";

export const getEnv = () => {
  if (typeof window === "undefined") {
    if (IS_DEV) {
      return "dev";
    }
    if (IS_PRE) {
      return "pre";
    }
    if (IS_PROD) {
      return "prod";
    }
    return "dev";
  } else {
    if (
      window.location.host.includes("pre") ||
      window.location.host.includes("chj")
    ) {
      return "pre";
    }
    if (window.location.host.includes("chuhaijiang")) {
      return "prod";
    }
    return "dev";
  }
};
export const getIsChj = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return window.location.host.includes("chj");
};
export const WECHAT_CLIENT_ID = process.env.WECHAT_CLIENT_ID ?? "";
export const WECHAT_CLIENT_SECRET = process.env.WECHAT_CLIENT_SECRET ?? "";
export const WECHAT_GZH_CLIENT_ID = process.env.WECHAT_GZH_CLIENT_ID ?? "";
export const WECHAT_GZH_CLIENT_SECRET =
  process.env.WECHAT_GZH_CLIENT_SECRET ?? "";

/** id > 100 是企业定制版 */
export enum RoleType {
  /**
   * 旧版企业版
   */
  ENTERPRISE = 1,

  /**
   * 旧版专业版
   */
  PROFESSIONAL = 2,

  /**
   * 旧版标准版
   */
  STANDARD = 3,

  /**
   * 旧版游客
   */
  NORMAL = 4,

  /**
   * 旧版未登录
   */
  UNLOGIN = 5,

  /**
   * 新版企业版
   */
  ENTERPRISE_V2 = 6,

  /**
   * 新版尊享版
   */
  EXCLUSIVE = 7,

  /**
   * 新版专业版
   */
  PROFESSIONAL_V2 = 8,

  /**
   * 基础版
   */
  BASIC = 9,

  /**
   * 新版体验版
   */
  EXPERIENCE = 10,

  /**
   * 新版普通会员
   */
  NORMAL_V2 = 11,

  /**
   * 新版游客
   */
  UNLOGIN_V2 = 12,

  /** 企业版v3 */
  ENTERPRISE_V3 = 1001,

  /** 尊享版v3 */
  EXCLUSIVE_V3 = 1002,

  /** 专业版v3 */
  PROFESSIONAL_V3 = 1003,

  /** 标准版v3 */
  BASIC_V3 = 1004,

  /** 入门版v3 */
  EXPERIENCE_V3 = 1005,
}

export const COUNTRY_CODE_KEY = "countryCode";
export enum CountryCode {
  US = "US",
  TH = "TH",
  MY = "MY",
  VN = "VN",
  MX = "MX",
  DE = "DE",
  FR = "FR",
  IT = "IT",
  ES = "ES",
  JP = "JP",
  BR = "BR",
}
export const asiaList = [CountryCode.TH, CountryCode.MY, CountryCode.VN];
export const europeList = [
  CountryCode.DE,
  CountryCode.FR,
  CountryCode.IT,
  CountryCode.ES,
];
const extraCountryList = [
  {
    name: "阿根廷",
    countryName: "阿根廷",
    currency: "ARS",
    code: "AR",
    translateTarget: "es",
    translateTips: "翻译搜索关键词为西班牙语(阿根廷)",
  },
];
export const countryList: {
  name: string;
  countryName: string;
  currency: string;
  code: string;
  translateTarget: string;
  translateTips: string;
}[] = [
  {
    name: "美国",
    countryName: "美国",
    currency: "$",
    code: CountryCode.US,
    translateTarget: "en",
    translateTips: "翻译搜索关键词为英文",
  },
  {
    name: "泰国",
    countryName: "泰国",
    currency: "฿",
    code: CountryCode.TH,
    translateTarget: "th",
    translateTips: "翻译搜索关键词为泰语",
  },
  {
    name: "马来西亚",
    countryName: "马来西亚",
    currency: "RM",
    code: CountryCode.MY,
    translateTarget: "ms",
    translateTips: "翻译搜索关键词为马来语",
  },
  {
    name: "越南",
    countryName: "越南",
    currency: "₫",
    code: CountryCode.VN,
    translateTarget: "vi",
    translateTips: "翻译搜索关键词为越南语",
  },
  {
    name: "墨西哥",
    countryName: "墨西哥",
    currency: "M$",
    code: CountryCode.MX,
    translateTarget: "es",
    translateTips: "翻译搜索关键词为西班牙语(墨西哥)",
  },
  {
    name: "德国",
    countryName: "德国",
    currency: "€",
    code: CountryCode.DE,
    translateTarget: "de",
    translateTips: "翻译搜索关键词为德语",
  },
  {
    name: "法国",
    countryName: "法国",
    currency: "€",
    code: CountryCode.FR,
    translateTarget: "fr",
    translateTips: "翻译搜索关键词为法语",
  },
  {
    name: "意大利",
    countryName: "意大利",
    currency: "€",
    code: CountryCode.IT,
    translateTarget: "it",
    translateTips: "翻译搜索关键词为意大利语",
  },
  {
    name: "西班牙",
    countryName: "西班牙",
    currency: "€",
    code: CountryCode.ES,
    translateTarget: "es",
    translateTips: "翻译搜索关键词为西班牙语",
  },
  {
    name: "日本",
    countryName: "日本",
    currency: "JP¥",
    code: CountryCode.JP,
    translateTarget: "ja",
    translateTips: "翻译搜索关键词为日语",
  },
  // {
  //   name: "巴西",
  //   countryName: "巴西",
  //   currency: "R$",
  //   code: CountryCode.BR,
  //   translateTarget: "es",
  //   translateTips: "翻译搜索关键词为葡萄牙语(巴西)",
  // },
];
export const disableCountryCodeList = ["/shopify", "/dropshipping"];

export const getInitialCountryCode = () => {
  if (typeof window === "undefined") return "US";
  const pathname = window.location.pathname;
  if (disableCountryCodeList.some((item) => pathname.startsWith(item))) {
    return "US";
  }
  const params = new URLSearchParams(window.location.search);
  const countryCode =
    window.sessionStorage.getItem(COUNTRY_CODE_KEY) ||
    params.get(COUNTRY_CODE_KEY);
  if (
    countryCode &&
    countryList.map((country) => country.code).includes(countryCode)
  ) {
    return countryCode;
  }
  return "US";
};
export const UNAUTHORIZED_NAMES = ["UNAUTHORIZED_ERROR", "OUT_OF_LIMIT_ERROR"];

export enum AiTaskType {
  /** 商品评论分析 */
  ProductReview = 1,
  /** 视频脚本提取 */
  VideoTranscription = 2,
  /** 带货视频脚本生成 */
  VideoScript = 3,
  /** 爆款视频脚本仿写 */
  ImitativeVideoScript = 4,
  /** 视频分镜分析 */
  VideoStoryboard = 5,
  /** 视频内容拆解 */
  VideoBreakdown = 6,
  /** 视频评论分析 */
  VideoCommentAnalysis = 7,
  /** 灵感库搜索 */
  InspirationSearch = 11,
  /** 智能切片 */
  IntelligentClip = 12,
}

export const shouldFitlerFieldList = ["tiktok_product_search_sold_count_trend"];

export enum ScriptLang {
  EN = "en",
  TH = "th",
  MS = "ms",
  VI = "vi",
  ES_MX = "es_mx",
  DE = "de",
  FR = "fr",
  IT = "it",
  ES = "es",
  JP = "ja",
  ES_BR = "es_br",
}
export const scriptLangMap: Record<CountryCode, ScriptLang> = {
  [CountryCode.US]: ScriptLang.EN,
  [CountryCode.TH]: ScriptLang.TH,
  [CountryCode.MY]: ScriptLang.MS,
  [CountryCode.VN]: ScriptLang.VI,
  [CountryCode.MX]: ScriptLang.ES_MX,
  [CountryCode.DE]: ScriptLang.DE,
  [CountryCode.FR]: ScriptLang.FR,
  [CountryCode.IT]: ScriptLang.IT,
  [CountryCode.ES]: ScriptLang.ES,
  [CountryCode.JP]: ScriptLang.JP,
  [CountryCode.BR]: ScriptLang.ES,
};
const scriptLabelMap: Record<ScriptLang, string> = {
  [ScriptLang.EN]: "英语",
  [ScriptLang.TH]: "泰语",
  [ScriptLang.MS]: "马来语",
  [ScriptLang.VI]: "越南语",
  [ScriptLang.ES_MX]: "西班牙语(墨西哥)",
  [ScriptLang.DE]: "德语",
  [ScriptLang.FR]: "法语",
  [ScriptLang.IT]: "意大利语",
  [ScriptLang.ES]: "西班牙语",
  [ScriptLang.JP]: "日语",
  [ScriptLang.ES_BR]: "葡萄牙语(巴西)",
};
export const scriptLangList = Object.values(ScriptLang).map((lang) => ({
  value: lang,
  label: scriptLabelMap[lang],
}));

export const whiteList = ["asia", "mx"];

export const checkCountryCode = (
  countryCode: CountryCode,
  grayFeature: string[],
) => {
  if (countryCode === CountryCode.MX && grayFeature.includes("mx")) {
    return true;
  }
  if (
    [CountryCode.TH, CountryCode.MY, CountryCode.VN].includes(countryCode) &&
    grayFeature.includes("asia")
  ) {
    return true;
  }
  return false;
};

export enum BanType {
  NORMAL = "NORMAL",
  LIMITED = "LIMITED",
  BANNED = "BANNED",
  TEMPORARY_BANNED = "TEMPORARY_BANNED",
}

export enum BanCode {
  // 需要通过图形验证码解封的临时封禁
  CAPTCHA_REQUIRED_BAN = 40003,
  // 永久封禁，无法解封
  PERMANENT_BAN = 40004,
  // 需要通过语音验证码解封的临时封禁
  VOICE_CAPTCHA_REQUIRED_BAN = 40005,
}

export const IS_NOT_PROD = process.env.API_BASE_V2?.includes("pre");

export const DEV_MAX_SESSION_COUNT = 100;

export const DEFAULT_MAX_SESSION_COUNT = 2;

export enum PlatformType {
  TIKTOK = "TIKTOK",
  SHOPIFY = "SHOPIFY",
}

export const getPlatformType = (entityTypeName: string) => {
  if (["shopify_seller", "shopify_product"].includes(entityTypeName)) {
    return PlatformType.SHOPIFY;
  }
  return PlatformType.TIKTOK;
};

export const DEFAULT_SEO_TITLE = "出海匠 - 中国出海卖家信赖的智能运营平台";
